module.exports = __webpack_public_path__ + "img/wszg-logo.80beb714.png";